import React from 'react';

import RegistrationWrapper from 'common/canny/register/RegistrationWrapper';
import AdminOnboardingFieldLabel from 'common/subdomain/admin/AdminOnboarding/AdminOnboardingFieldLabel';
import AdminOnboardingMultiSelect from 'common/subdomain/admin/AdminOnboarding/AdminOnboardingMultiSelect';
import TextInputV2 from 'common/ui/TextInputV2';
import VStack from 'common/ui/VStack';
import useDelayer from 'common/util/useDelayer';

import {
  communicationToolOptions,
  internalToolOptions,
  projectManagementToolOptions,
} from './data';

import type { RegistrationStepProps } from 'common/subdomain/admin/AdminOnboarding/Types';

const AdminOnboardingTools = ({ onChange, onboarding }: RegistrationStepProps) => {
  const updateCommunicationTools = (newSelectedTools: string[]) => {
    onChange({
      communicationTools: newSelectedTools,
    });
  };

  const updateInternalTools = (newSelectedTools: string[]) => {
    onChange({
      internalTools: newSelectedTools,
    });
  };

  const updateProjectManagementTools = (newSelectedTools: string[]) => {
    onChange({
      projectManagementTools: newSelectedTools,
    });
  };

  const updateOtherTools = (otherTools: string) => {
    const toolsArray = otherTools
      .split(',')
      .map((tool) => tool.trim())
      .filter((tool) => tool.length > 0);

    onChange({
      otherTools: toolsArray,
    });
  };

  return (
    <RegistrationWrapper.Content>
      <RegistrationWrapper.Header>
        <RegistrationWrapper.Title>Which tools does your team use?</RegistrationWrapper.Title>
        <RegistrationWrapper.Description>
          This will customize your onboarding
        </RegistrationWrapper.Description>
      </RegistrationWrapper.Header>
      <VStack className="gap-7">
        <VStack className="gap-2">
          <AdminOnboardingFieldLabel>Customer communication</AdminOnboardingFieldLabel>
          <AdminOnboardingMultiSelect
            onChange={updateCommunicationTools}
            options={communicationToolOptions}
            selected={onboarding.communicationTools}
          />
        </VStack>
        <VStack className="gap-2">
          <AdminOnboardingFieldLabel>Internal communication</AdminOnboardingFieldLabel>
          <AdminOnboardingMultiSelect
            onChange={updateInternalTools}
            options={internalToolOptions}
            selected={onboarding.internalTools}
          />
        </VStack>
        <VStack className="gap-2">
          <AdminOnboardingFieldLabel>Project management</AdminOnboardingFieldLabel>
          <AdminOnboardingMultiSelect
            onChange={updateProjectManagementTools}
            options={projectManagementToolOptions}
            selected={onboarding.projectManagementTools}
          />
        </VStack>
        <VStack className="gap-2">
          <AdminOnboardingFieldLabel>Anything else?</AdminOnboardingFieldLabel>
          <TextInputV2
            placeholder="Other tools…"
            size="large"
            className="max-w-[450px]"
            defaultValue={onboarding.otherTools.join(', ')}
            onChange={useDelayer(updateOtherTools, 500)}
          />
        </VStack>
      </VStack>
    </RegistrationWrapper.Content>
  );
};

export default AdminOnboardingTools;
